import React from 'react';
import { useRouteMatch } from 'react-router';
import { useDishFirstExploreUrl } from 'src/pages/consumer/explore/useExploreUrl';
import { useCachedZipCode } from 'src/user-preferences/useCachedZipCode';
import { BaseFilterModal } from '../BaseFilterModal';
import { DishRating } from './DishRating';
import { DishType } from './DishType';
import { EcoPackaging } from './EcoPackaging';
import { PriceRange } from './PriceRange';
import { SpiceLevel } from './SpiceLevel';
import { Main } from './styles';
import { MoreFiltersModalProps } from './types';

export const MoreFiltersModal: React.FC<MoreFiltersModalProps> = ({ header, isShowing, largeHeader, onHide }) => {
  const match = useRouteMatch();
  const filters = useDishFirstExploreUrl({ match });
  const [, , zipCodeMetaData] = useCachedZipCode();

  // check if the region id matched Bay Area region id
  const ecoPackagingEnabled = zipCodeMetaData.cachedZipCodeData?.zipCode?.region.ecoPackagingEnabled;

  return (
    <BaseFilterModal filters={filters} header={header} isShowing={isShowing} largeHeader={largeHeader} onHide={onHide}>
      <Main.Container>
        <DishRating filters={filters} />
        <SpiceLevel filters={filters} />
        <DishType filters={filters} />
        <PriceRange filters={filters} />
        {ecoPackagingEnabled && <EcoPackaging filters={filters} />}
      </Main.Container>
    </BaseFilterModal>
  );
};
